import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useLanguage } from "../../context/LanguageContext";

export const Faq = () => {
  const { t } = useLanguage();
  return (
    <section id="faq" data-testid="faq-section" className="py-28 md:py-36 border-t border-white/10">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-14"
        >
          <p className="font-mono-tech text-xs tracking-[0.25em] uppercase text-[#60A5FA] mb-6" data-testid="faq-overline">
            {t.faq.overline}
          </p>
          <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl md:text-5xl" data-testid="faq-title">
            {t.faq.title}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
        >
          <Accordion type="single" collapsible>
            {t.faq.items.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display font-medium text-lg md:text-xl hover:text-[#60A5FA] transition-colors py-6"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 text-base leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
